let BASE_API_URL: string;
let BASE_CDN_URL: string;

switch (window.location.hostname) {
  case 'website.uat.dotcapitals.dotnu.co':
    BASE_API_URL = process.env.REACT_APP_CAPITALS_UAT_BASE_API_URL || '';
    break;
  default:
    BASE_CDN_URL = process.env.REACT_APP_CAPITALS_CDN_URL || '';
    BASE_API_URL = process.env.REACT_APP_CAPITALS_BASE_API_URL || '';
}

export { BASE_API_URL, BASE_CDN_URL };
